import { render, staticRenderFns } from "./stackColumnVertical.vue?vue&type=template&id=15c0dbff&scoped=true"
import script from "./stackColumnVertical.vue?vue&type=script&lang=js"
export * from "./stackColumnVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c0dbff",
  null
  
)

export default component.exports